import { CONTENT, type P3Question } from "@/content";
import { apiFetch } from "./api";

export type EditableQuestion =
  | { kind: "text"; text: string; hint: string }
  | { kind: "scale"; text: string; hint: string }
  | { kind: "choice"; text: string; hint: string; options: string[] };

type QuestionsResponse = {
  questions: EditableQuestion[] | null;
  updated_at: string | null;
};

export function tupleToQuestion(question: P3Question): EditableQuestion {
  const [text, hint, kind] = question;
  if (kind === "choice") {
    return { kind, text, hint, options: question[3] };
  }
  return { kind, text, hint };
}

export function questionToTuple(question: EditableQuestion): P3Question {
  if (question.kind === "choice") {
    return [question.text, question.hint, question.kind, question.options];
  }
  return [question.text, question.hint, question.kind];
}

export const defaultEditableQuestions: EditableQuestion[] = CONTENT.p3.questions.map(tupleToQuestion);

export function toP3Questions(questions: EditableQuestion[] | null | undefined): P3Question[] {
  return (questions && questions.length ? questions : defaultEditableQuestions).map(questionToTuple);
}

export async function fetchPublicQuestions(): Promise<EditableQuestion[] | null> {
  const res = await apiFetch<QuestionsResponse>("/form/questions");
  return res.questions;
}

export async function fetchAdminQuestions(): Promise<QuestionsResponse> {
  return apiFetch<QuestionsResponse>("/admin/form/questions", { auth: "admin" });
}

export async function saveAdminQuestions(questions: EditableQuestion[]): Promise<void> {
  await apiFetch("/admin/form/questions", {
    method: "PATCH",
    auth: "admin",
    body: { questions },
  });
}
